/**
 * Configuration for API URL endpoint.
 *
 * Dynamic based on introspection of where the application is running (local, staging, production).
 *
 * @returns {string} Application URL
 */
export default {
  API_URL: (() => {
    if (window.location.host.includes('localhost')) {
      return 'http://localhost.rms-live.com:8080/rms-live/api/v2/';
    } else if (window.location.host.includes('staging')) {
      // Staging
      return 'https://portal7.resortplanet-staging.com/rms-live/api/v2/';
    }
    // Production
    return 'https://portal7.resortplanet.com/rms-live/api/v2/';
  })()
};
